export default class Config {
    static get MAGIC_WAND_DEFAULT_LEVEL() {
        return 65
    }
    static get MAGIC_WAND_MAX_LEVEL() {
        return 90
    }

    static get DEFAULT_MASKING_COLOR() {
        return 255
    }
}
